"use client";
import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Link from "next/link";
import HighlightsAndStats from '@/components/HighlightsAndStats';

export default function TermsAndConditions() {
    const [openIndex, setOpenIndex] = useState(null);
    const [showAll, setShowAll] = useState(false);

    const stats = {
        announcements: [
            "to features Learn & Earn during Degree",
            "to promote NEP2020 with Industry Integration",
            "to promote Overseas Mobility",
            "to be the Awarding Body of UGC & NCVET, MSDE, Gol"
        ],
        stats: [
            { label: 'Industry & Skilling Partners', value: '650+' },
            { label: 'Sectors Covered', value: '30+' },
            { label: 'Central Ministries & State Government Partners', value: '20+' },
            { label: 'CSR Partners', value: '20+' },
            { label: 'Defence Partners', value: '10+' }
        ]
    };

    const data = [
        { title: "Content Editing and Deletion", content: "We retain the exclusive authority to review and modify or remove any documents, data, or other materials displayed on the Site at our discretion.", pdf: "" },
        {
            title: "Indemnification", content: "You agree to indemnify, defend, and safeguard us, along with our associates, legal representatives, personnel, and affiliates (collectively referred to as “Affiliated Parties”), from any legal liability, loss, claim, or expense, including reasonable attorney’s fees, connected to your infringement of this Agreement or use of the Site.", pdf: ""
        },
        { title: "Non-Transferability", content: "Your right to access the Site is non-transferable. Any password or authorization granted to you for obtaining information or documents is not transferable.", pdf: "" },
        { title: "Disclaimer", content: "The information and services may contain defects, inaccuracies, issues, or other constraints. We and our affiliated parties are not accountable for any consequences resulting from your use of any information or service. This specifically includes, but is not restricted to, indirect, special, incidental, or consequential damages (including losses related to business, profit, litigation, or similar matters), whether due to contract violation, warranty breach, negligence, product liability, or any other cause, even if you’ve been informed of the potential for such damages. The exclusion of damages outlined above is an integral aspect of our agreement. This site and the information would not be made available without these constraints. Any advice or information, whether oral or written, acquired from us through the site, does not establish any warranty, representation, or assurance not explicitly stated in this agreement.", pdf: "" },
        { title: "Information Usage", content: "When you voluntarily send us electronic mail / fillup the form, we will keep a record of this information so that we can respond to you. We only collect information from you when you register on our site or fill out a form. Also, when filling out a form on our site, you may be asked to enter your: name, e-mail address or phone number. You may, however, visit our site anonymously. In case you have submitted your personal information and contact details, we reserve the rights to Call, SMS, Email or WhatsApp about our products and offers, even if your number has DND activated on it. We hold the right, and you authorize us, to utilize and transfer all data related to your use of the Site and all data provided by you, in accordance with our Privacy Policy.", pdf: "" },
        { title: "Privacy Policy", content: "Our Privacy Policy, as it might change over time, is an integral part of this Agreement.", pdf: "" },
        { title: "Links to Other Websites", content: "The Site contains hyperlinks to other websites. We are not responsible for the content, accuracy, or viewpoints expressed on such websites, and we do not investigate, monitor, or validate their accuracy or completeness. Inclusion of any linked website on our Site does not imply our endorsement or approval of the linked website. If you decide to leave our Site and access these third-party websites, you do so at your own risk.", pdf: "" },
        { title: "Information and Press Releases", content: "The Site may feature information and press releases regarding our organization. While this information was believed to be accurate at the time of publication, we disclaim any responsibility or obligation to update this information or any press releases. Information about entities other than ours, found in press releases or otherwise, should not be relied upon as provided or endorsed by us.", pdf: "" },
        { title: "Refund Policy", content: "Any student can apply for a refund of a Partial or Full fee and it can be refunded if any genuine reason is found but it is solely at the discretion of the University and its Governing Body.", pdf: "" },
        { title: "Admission Cancellation Policy", content: "Any student can apply for admission cancellation and it can be processed if any genuine reason is found but it is solely at the discretion of the University and its Governing Body.", pdf: "" },
        { title: "Questions or Suggestions", content: "For any questions or suggestions send an email to us at contact@msu.edu.in contact@msu.edu.in", pdf: "https://cdn.msu.edu.in/pdf/MSU_Cancellation_Policy_2024_2025.pdf" },

    ];

    const visibleItems = showAll ? data : data.slice(0, 5);

    return (
        <section className="w-full flex justify-center ">
            <div className="max-w-[var(--max-page-width)] w-full px-[var(--container-padding)] my-6 md:my-10 lg:my-14">
                <div className="grid grid-cols-1 ">
                    <div className="bg-white w-full">
                        <h2 className="font-extrabold text-[clamp(20px,3vw,42px)] text-black mb-4">
                            Terms and Conditions
                        </h2>

                        <div className="border-t border-gray-200">
                            {visibleItems.map((item, index) => {
                                const isOpen = openIndex === index;

                                return (
                                    <div key={index} className="p-6 shadow-[0_4px_12px_rgba(0,0,0,0.15)] rounded-sm my-3">
                                        <button
                                            onClick={() =>
                                                setOpenIndex(isOpen ? null : index)
                                            }
                                            className="w-full flex justify-between items-center text-left  cursor-pointer"
                                        >
                                            <span className="text-2xl font-semibold text-black">
                                                {item.title}
                                            </span>

                                            {isOpen ? (
                                                <Minus className="text-[#081E2D]" />
                                            ) : (
                                                <Plus className="text-[#081E2D]" />
                                            )}
                                        </button>

                                        {isOpen && (
                                            <div className="mt-3 text-gray-600 text-lg leading-relaxed animate-fadeIn flex flex-col gap-2">
                                                {item.content}

                                                {item.pdf && (
                                                    <Link
                                                        href={item.pdf}
                                                        target="_blank"
                                                        className="w-35 text-center inline-block mt-3 text-[#081E2D] font-semibold 
                                                        border border-[#081E2D] px-5 py-2 hover:bg-[#081E2D] hover:text-white transition"
                                                    >
                                                        View PDF
                                                    </Link>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        {!showAll && (
                            <div className="mt-6">
                                <button
                                    onClick={() => setShowAll(true)}
                                    className="cursor-pointer px-4 py-2 border border-[#081E2D] text-[#081E2D] hover:bg-[#081E2D] hover:text-white transition"
                                >
                                    View all Terms and Conditions
                                </button>
                            </div>
                        )}

                    </div>
                </div>

                <HighlightsAndStats data={stats} />
            </div>
        </section>
    );
}
